import { Component } from '@angular/core';
import { IonicPage, LoadingController, NavController, ToastController } from 'ionic-angular';

import { QuizzAboutPage } from '../quizz-about/quizz-about';

import { ProofServerProvider } from '../../providers/proof-server/proof-server';
import { ProofFinishedDetailPage } from '../proof-finished-detail/proof-finished-detail';
import { EventEmitterProvider } from '../../providers/event-emitter/event-emitter';
import { QuizzServerProvider } from '../../providers/quizz-server/quizz-server';

import * as Config from '../../app/app.config';

/**
 * Generated class for the ProofFinishedListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
    selector: 'page-proof-finished-list',
    templateUrl: 'proof-finished-list.html',
})
export class ProofFinishedListPage {

    loading: boolean = false;
    proofs: any = [];

    private canContractQuizz: boolean = false;
    private canContractQuizzSubscription: any;

    constructor(
        private navCtrl: NavController,
        private loadingCtrl: LoadingController,
        private toastCtrl: ToastController,
        private proofServerProvider: ProofServerProvider,
        private eventEmitterProvider: EventEmitterProvider,
        private quizzServerProvider: QuizzServerProvider,
    ) {
        this.doUpdate();

        if (Config.quizzEnabled) {
            const that = this;
            this.canContractQuizzSubscription = this.eventEmitterProvider.get('can_contract_quizz').subscribe((canContractQuizz: boolean) => {
                if ((canContractQuizz !== null) && (canContractQuizz !== undefined)) {
                    that.canContractQuizz = canContractQuizz;
                } else {
                    that.canContractQuizz = true;
                }
            });

            if (this.quizzServerProvider.getCanContractQuizz()) {
                this.canContractQuizz = true;
            }
        }
    }

    // ionViewDidLoad() {
    //     console.log('ionViewDidLoad ProofFinishedListPage');
    // }

    ionViewWillLeave() {
        if (Config.quizzEnabled) {
            this.canContractQuizzSubscription.unsubscribe();
        }
    }

    doUpdate() {
        this.loading = true;

        let loader = this.loadingCtrl.create({
            content: 'Obtendo provas concluídas...',
        });
        loader.present();

        let that = this;
        this.proofs = [];

        this.proofServerProvider.fetchFinisheds().subscribe(proofs => {
            that.loading = false;

            try {
                if (proofs.length > 0) {
                    for (let pi = 0; pi < proofs.length; pi++) {
                        let proof = proofs[pi];

                        if (proof.createdAt) {
                            proof.createdAt = new Date(proof.createdAt.replace(/\s+/g, 'T').concat('.000-03:00'));
                        }

                        if (proof.finishedAt) {
                            proof.finishedAt = new Date(proof.finishedAt.replace(/\s+/g, 'T').concat('.000-03:00'));
                        }

                        that.proofs.push(proof);
                    }
                }
            } catch (ex) {
                that.doNotRetrivedProofs(ex);
            }

            loader.dismiss();
        }, (error: any) => {
            that.loading = false;
            loader.dismiss();
            that.doNotRetrivedProofs(error);
        });
    }

    private doNotRetrivedProofs(error = null) {
        this.proofs = [];

        // console.log('Não foi possível obter as provas concluídas.', error);

        let toast = this.toastCtrl.create({
            message: 'Não foi possível obter as provas concluídas.',
            duration: 3000,
            position: 'bottom'
        });

        toast.present();
    }

    /**
     * Get the detail of response back.
     *
     * @param proof Proof.
     */
    getDetail(proof: any) {
        this.navCtrl.push(ProofFinishedDetailPage, {
            proof: proof
        });
    }

    goToQuizzAboutPage() {
        this.navCtrl.setRoot(QuizzAboutPage);
        this.navCtrl.popToRoot({
            animation: 'ios-transition'
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/proof-finished-list/proof-finished-list.ts